import mapboxgl, { LineLayout } from "mapbox-gl";

export const roundedLineLayout: LineLayout = {
    "line-join": "round",
    "line-cap": "round",
};

export const genericPointLayer = (
    lyrName: string,
    sourceName: string,
    circleRadius: number,
    colorFieldName?: string
): mapboxgl.Layer => {
    const _c = colorFieldName ? colorFieldName : "color";

    return {
        id: lyrName,
        source: sourceName,
        type: "circle",
        paint: {
            "circle-color": ["get", _c],
            "circle-radius": circleRadius,
        },
    } as mapboxgl.Layer;
};

export const genericLineLayer = (
    lyrName: string,
    sourceName: string,
    lineWidth = 11,
    lineOpacity = 0.7
): mapboxgl.Layer => {
    return {
        id: lyrName,
        source: sourceName,
        type: "line",
        paint: {
            "line-color": ["get", "color"],
            "line-opacity": lineOpacity,
            "line-width": lineWidth,
        },
        layout: roundedLineLayout,
    } as mapboxgl.Layer;
};

export const hoverablePointLayer = (
    lyrName: string,
    sourceName: string,
    circleRadius: number,
    color: string
): mapboxgl.Layer => {
    return {
        id: lyrName,
        source: sourceName,
        type: "circle",
        paint: {
            "circle-color": color,
            "circle-radius": circleRadius,
            "circle-opacity": [
                "case",
                ["boolean", ["feature-state", "hover"], false],
                1,
                0,
            ],
        },
    } as mapboxgl.Layer;
};

export const addLayersIfNotExist = (
    map: mapboxgl.Map,
    layers: mapboxgl.Layer[]
): void => {
    layers.forEach((layer: mapboxgl.Layer) => {
        if (!map.getLayer(layer.id)) {
            map.addLayer(layer as any);
        }
    });
};

export const safeRemoveLayers = (
    map: mapboxgl.Map,
    layers: mapboxgl.Layer[]
): void => {
    layers.forEach((layer: mapboxgl.Layer) => {
        if (map.getLayer(layer.id)) {
            map.removeLayer(layer.id);
            console.debug("Removed layer...", layer.id);
        }
    });
};
